module.exports = __webpack_public_path__ + "img/ft2.105902b2.webp";